import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('alpine-snackbar'),_c('message-dialog',{ref:"msgDialogAppVue",attrs:{"confirm-text":"Yes","cancel-text":"No"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }